module.exports = __webpack_public_path__ + "static/media/icon-to-sign.8edac8e1.svg";